import { jsx } from 'react/jsx-runtime';
import { DropdownInput } from '@dls/web';
import { forwardRef, useState, useEffect } from 'react';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const SearchableDropdownInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      items
    } = _b,
    rest = __objRest(_b, ["items"]);
  const [options, setOptions] = useState(items);
  const [resetTime, setResetTime] = useState();
  useEffect(() => {
    setOptions(items);
  }, [items]);
  const handleSearch = e => {
    if (e.target.value) {
      setOptions(items.filter(i => i.text.toLowerCase().includes(e.target.value.toLowerCase())));
    } else {
      setOptions(items);
    }
  };
  const handleBlur = () => {
    setResetTime( /* @__PURE__ */new Date().getTime());
    setOptions(items);
  };
  return /* @__PURE__ */jsx("span", {
    onBlur: handleBlur,
    children: /* @__PURE__ */jsx(DropdownInput, __spreadProps(__spreadValues({}, rest), {
      items: options,
      ref,
      hasSearch: true,
      onSearch: handleSearch
    }), resetTime)
  });
});
export { SearchableDropdownInput as default };